/* Блок «Съёмка» (APP-SPEC-5 §1.9) экранов фотосессий. Общий StudioShooting знает только «Как в стиле» по полю `style`
   экранов «Фото»/«Видео»; у фотосессий умолчание контекста — образ («Как в образе») или главная сцена набора («Как в сцене»).
   Локальная обёртка подставляет признак выбранного образа/сцены, ничего не добавляя в заказ: setInputs идёт в настоящую форму.
   В общее стоит перенести: параметр `styled` (и `reference`) у StudioShooting вместо чтения inputs.style. */
import { useMemo } from 'react';
import { StudioShooting } from '../../studio/StudioShooting';
import type { useStudioForm } from '../../studio/use-studio-form';

type FormState = ReturnType<typeof useStudioForm>;
export function ShootingBlock({ state, styled, referenced }: { state: FormState; styled: boolean; referenced: boolean }) {
  const proxy = useMemo(() => {
    const inputs = { ...state.inputs };
    delete inputs.style;
    delete inputs.reference;
    if (styled) inputs.style = 'context';
    if (referenced) inputs.reference = 'context';
    return { ...state, inputs };
  }, [state, styled, referenced]);
  return <StudioShooting state={proxy} />;
}
